import { MutationTree } from "vuex";
import { IDataProvider } from "@/store";
import { IReportTemplateState } from "@/store/modules/reportTemplate/state";
import { ReportTemplate } from "@/types/report/ReportTypes";

export enum ReportTemplateMutations {
  SET_ONE = "SET_ONE_REPORT_TEMPLATE",
  SET_ALL = "SET_ALL_REPORT_TEMPLATE",
  SET_LAZY_DATA = "SET_LAZY_DATA_REPOR_TEMPLATE",
}

export const mutations: MutationTree<IReportTemplateState> = {
  [ReportTemplateMutations.SET_ONE](state, payload: ReportTemplate) {
    state.reportTemplate = payload;
  },
  [ReportTemplateMutations.SET_ALL](state, payload: ReportTemplate[]) {
    state.reportTemplates = payload;
  },
  [ReportTemplateMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<ReportTemplate>
  ) {
    state.dataProvider = payload;
  },
};
